
if (typeof window.SVGElement.prototype.focus === 'undefined') { window.SVGElement.prototype.focus = function () {} }
